import React from "react";
import BusinessTypeTable from "./view/BusinessTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const BusinessType = () => {
  const viewBusinessTypePermission =
    PERMISSIONS.permission_utilities_configureagreement_businesstype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div>
      {userPermissions.includes(viewBusinessTypePermission) && (
        <BusinessTypeTable />
      )}
    </div>
  );
};

export default BusinessType;
